export class TransmettreEncaissementsRequest {
    constructor() {
        this.pieceIds = [];
    }

    public pieceIds: string[];
}

export class TransmettreEncaissementsResultat {
    constructor() {
        this.piecesPasEncoreTransmises = [];
        this.piecesSansEncaissements = [];
        this.piecesSucces = [];
        this.piecesParametragePAIntrouvable = [];
        this.piecesEnErreur = {};
        this.dateDerniereTransmission = null;
    }

    public piecesPasEncoreTransmises: string[];
    public piecesSansEncaissements: string[];
    public piecesSucces: string[];
    public piecesParametragePAIntrouvable: string[];
    public piecesEnErreur: Record<string, string>;
    public dateDerniereTransmission: Date | null;
}
